import EditBookingModal from 'components/modals/EditBookingModal';
import useModal from 'components/remodal/v2/useModal';
import useBreakpoints, { SMALLSCREEN_QUERY } from 'hooks/useBreakpoints';
import { Booking } from 'swagger/models';

const useEditBookingModal = (booking: Booking, onSuccess?) => {
  const [smallScreen] = useBreakpoints(SMALLSCREEN_QUERY);

  const { modal, openModal } = useModal(<EditBookingModal booking={booking} onSuccess={onSuccess} />, {
    isOnRight: true,
    title: smallScreen && 'Edit booking',
    trackingName: 'edit_booking_modal',
  });
  const isAvailable = booking?.can_modify && ['payment_held', 'unverified', 'approved'].includes(booking?.state);

  return { isAvailable, modal, openModal };
};

export default useEditBookingModal;
